<template>
  <el-container class="cityD">
    <el-header style="padding: 0" height="100%">
      <vheader class="hidden-sm-and-down"></vheader>
      <ivheadera class="hidden-md-and-up"></ivheadera>
      <div class="top-img">
        <img class="hidden-sm-and-down" width="100%" src="../../assets/images/en/A/D-topImg.png" alt="" />
        <img class="hidden-md-and-up" width="100%" src="../../assets/images/en/A/D-topImg-m.png" alt="" />
        <div class="top-img-top"><p>Subsidies</p></div>
        <div class="ec-top-foot">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><a href="http://www.cityplus.com/">首页</a></el-breadcrumb-item>
            <el-breadcrumb-item>深圳生活</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </div>
    </el-header>
    <div class="header-nav hidden-md-and-up">
      <el-row>
        <el-col :xs="16" :sm="16" :md="16">
          <div class="sub-h-nav">
            <el-row v-show="subShow">
              <el-col :span="12" v-for="(item, index) in navTitle" v-bind:key="index">
                <div class="sub-select" @click="subSelect(index)">{{ item.txt }}</div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :xs="8" :sm="8" :md="8">
          <div class="main-h-nav1">
            <div class="menu" @click="menuOpen">
              <i class="el-icon-arrow-right" :class="menuShow ? 'is-open' : ''"></i>
              <span>导航</span>
            </div>
            <transition name="menu-fade">
              <div class="menu-list" v-show="menuShow">
                <ul>
                  <li class="menu-item" @click="mainSelect('1')">创业补贴扶持政策</li>
                  <li class="menu-item" @click="mainSelect('2')">创业必备知识</li>
                  <li class="menu-item" @click="mainSelect('3')">税务、法务须知</li>
                  <li class="menu-item" @click="mainSelect('4')">签证选择与移民</li>
                  <li class="menu-item" @click="mainSelect('5')">公司设立指引</li>
                  <div class="back-btn" @click="menuShow = false">
                    <i class="el-icon-arrow-right"></i>
                    <span>返回</span>
                  </div>
                </ul>
              </div>
            </transition>
          </div>
          <!--            <div class="main-h-nav">-->
          <!--              <el-menu  mode="vertical" default-active="2"  @open="handleOpen" @close="handleClose" class="el-menu-vertical-demo" background-color="#000000b3"  text-color="#C8C8C8" active-text-color="#10B7D1">-->
          <!--                <el-submenu index="1">-->
          <!--                  <template slot="title">-->
          <!--                    <span>导航</span>-->
          <!--                  </template>-->
          <!--                  <div>-->
          <!--                    <el-menu-item-group index="2">-->
          <!--                      <el-menu-item  @click="mainSelect('1');">创业补贴扶持政策</el-menu-item>-->
          <!--                      <el-menu-item  @click="mainSelect('2')">创业必备知识</el-menu-item>-->
          <!--                      <el-menu-item  @click="mainSelect('3')">税务、法务须知</el-menu-item>-->
          <!--                      <el-menu-item  @click="mainSelect('4')">签证选择与移民</el-menu-item>-->
          <!--                      <el-menu-item  @click="mainSelect('5')">公司设立指引</el-menu-item>-->
          <!--                      &lt;!&ndash;                    <div>返回</div>&ndash;&gt;-->
          <!--                    </el-menu-item-group>-->
          <!--                  </div>-->
          <!--                </el-submenu>-->
          <!--              </el-menu>-->
          <!--            </div>-->
        </el-col>
      </el-row>
    </div>
    <el-main>
      <div class="w mida">
        <el-row type="flex">
          <el-col :sm="24" :md="24" :lg="24">
            <div class="mian-right">
              <div class="nav">
                <div>NAVIGATION</div>
                <div>导航</div>
              </div>
              <el-tabs class="mii" :tab-position="tabPosition" v-model="acName">
                <el-tab-pane class="cyyy" label="创业补贴扶持政策" name="1">
                  <div class="nav-title">
                    <img class="hidden-sm-and-down" width="50%" src="../../assets/images/D/SUB.png" alt />
                    <img class="hidden-md-and-up" width="55%" src="../../assets/images/D/SUB-m.png" alt />
                  </div>
                  <el-row type="flex" justify="center">
                    <el-col :sm="24" :md="20" :lg="20">
                      <el-tabs v-model="activeName" @tab-click="handleClick" class="mian-left-l">
                        <el-tab-pane label="" name="first">
                          <el-collapse accordion>
                            <div class="tem-img">
                              <img class="hidden-sm-and-down" width="100%" :src="subsidies1[0]" alt="" />
                              <img class="hidden-md-and-up" width="100%" :src="subsidies1[1]" alt="" />
                              <div class="cnts-item i-one">
                                <h1>深圳市海外高层次海外留学人才补贴</h1>
                                <ul>
                                  <li>
                                    <div>
                                      <i><span>01</span>深圳市海外高层次人才概述：</i>
                                      <p>海外高层次人才是指企业技术与创新创业、科研学术与教育卫生、文化艺术与体育三个领域的国（境）外高级专家和留学回国人员，其中国（境）外高级专家分为A、B两类，留学回国人员分为A、B、C三类。A类人才对应《深圳市高层次专业人才认定办法（试行）》中的国家级领军人才、B类人才对应地方级领军人才、C类人才对应后备级人才。</p>
                                    </div>
                                  </li>
                                  <li>
                                    <div>
                                      <i><span>02</span>海外高层次人才确认基本条件：</i>
                                      <p>1、遵纪守法，具有良好的职业道德，严谨的科研作风和科学、求实、团结、协作的精神；</p>
                                      <p>2、外籍高级专家需与应聘单位签订一年以上的聘用合同；留学回国人员应是来深创业或已与在深单位签订聘用合同的优秀人才；</p>
                                      <p>3、满足年龄要求：</p>
                                      <p>（1）海外高层次A类人才年龄应在60周岁以下；</p>
                                      <p>（2）海外高层次B类人才年龄应在55周岁以下；</p>
                                      <p>（3）海外高层次C类人才年龄应在40周岁以下。</p>
                                      <el-row class="one-left-row" type="flex">
                                        <el-col :sm="24" :md="8" :lg="8">
                                          <div>
                                            <img src="../../assets/images/D/one-code1.png" alt="">
                                            <h3>A类人才（300万）</h3>
                                            <h3>申请条件：</h3>
                                            <p>诺贝尔奖获得者、世界知名奖项获得者、指定国家科学院院士或工程院院士、名企或世界知名组织负责人、国际著名专业类奖项获得者等。详情请查看二维码。</p>
                                          </div>
                                        </el-col>
                                        <el-col :sm="24" :md="8" :lg="8">
                                          <div>
                                            <img src="../../assets/images/D/one-code2.png" alt="">
                                            <h3>B类人才（200万）</h3>
                                            <h3>申请条件：</h3>
                                            <p>国际著名学术界领军人才、省市领军人才、世界知名高校负责人、国际著名专业类奖项获得者等。详情请查看二维码。</p>
                                          </div>
                                        </el-col>
                                        <el-col :sm="24" :md="8" :lg="8">
                                          <div>
                                            <img src="../../assets/images/D/one-code3.png" alt="">
                                            <h3>C类人才（160万）</h3>
                                            <h3>申请条件：</h3>
                                            <p>担任过境外世界知名大学助理教授、海外高层次人才团队的核心成员、世界著名乐团演奏员和发明专利的主要发明人等。详情请查看二维码。 </p>
                                          </div>
                                        </el-col>
                                      </el-row>
                                    </div>
                                  </li>
                                </ul>
                                <h1>深圳前海境外高端人才和紧缺人才个人所得税财政补贴</h1>
                                <i>资助标准：</i>
                                <el-row class="one-left-row2">
                                  <el-col :sm="24" :md="16" :lg="16">
                                    <ul>
                                      <li>财政补贴=个人所得税已纳税额-应纳税所得额*15%</li>
                                      <li>在前海缴纳个人所得税已纳税额超过应纳税所得额的15%部分由财政补贴</li>
                                      <li>财政补贴免征个人所得税。</li>
                                      <p>咨询方式：0755-88988988 (工作日8:00-12:00/13:30-19:00)</p>
                                      <p>办事地点：深圳市前海深港合作区前湾一路1号A栋前海E站通服务中心</p>
                                    </ul>
                                  </el-col>
                                  <el-col :sm="24" :md="8" :lg="8">

                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane label="" name="second">
                          <el-col>
                            <div class="policy-centent-box" v-html="subsidies.ONE"></div>
                            <div class="policy-centent-box" v-html="subsidies.TWO"></div>
                            <div class="policy-centent-box" v-html="subsidies.THREE"></div>
                            <div class="policy-centent-box" v-html="subsidies.FOUR"></div>
                            <div class="policy-centent-box" v-html="subsidies.FIVE"></div>
                          </el-col>
                        </el-tab-pane>
                      </el-tabs>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane class="cyyy" label="创业必备知识" name="2">
                  <div class="nav-title">
                    <img class="hidden-sm-and-down" width="100%" src="../../assets/images/D/ENK.png" alt />
                    <img class="hidden-md-and-up" width="55%" src="../../assets/images/D/ENK-m.png" alt />
                  </div>
                  <el-row type="flex" justify="center">
                    <el-col :sm="24" :md="20" :lg="20">
                      <el-tabs v-model="activeName" @tab-click="handleClick" class="mian-left-l">
                        <el-tab-pane label="" name="first">
                          <el-collapse accordion>
                            <el-collapse-item>
                              <div slot="title" class="item-txt">
                                <img src="../../assets/images/D/01.png" alt class="enen" />
                                <img src="../../assets/images/D/concr.png" alt class="item-i" />
                                <span class="item-txt-t">涉及成立公司的词语</span>
                                <span class="item-txt-m">Noun iterpretation</span>
                              </div>
                              <div v-html="essential.ONE"></div>
                              <!--                                <div v-html="essential.TWO"></div>-->
                              <!--                                <div v-html="essential.THREE"></div>-->
                              <!--                                <div v-html="essential.FOUR"></div>-->
                            </el-collapse-item>
                            <el-collapse-item>
                              <div slot="title" class="item-txt">
                                <img src="../../assets/images/D/02.png" alt class="enen" />
                                <img src="../../assets/images/D/director.png" alt class="item-i" />
                                <span class="item-txt-t">股东会、董事会及监事会的关系图</span>
                                <span class="item-txt-m">Relationshlp dlagram</span>
                              </div>
                              <div class="tem-img">
                                <img class="hidden-sm-and-down" width="100%" :src="essential12[0]" alt="" />
                                <img class="hidden-md-and-up" width="100%" :src="essential12[1]" alt="" />
                              </div>
                            </el-collapse-item>
                            <el-collapse-item>
                              <div slot="title" class="item-txt">
                                <img src="../../assets/images/D/03.png" alt class="enen" />
                                <img src="../../assets/images/D/defect.png" alt class="item-i" />
                                <span class="item-txt-t">公司性质优缺点对比</span>
                                <span class="item-txt-m">Advantages and disadvantages</span>
                              </div>
                              <div class="tem-img">
                                <img class="hidden-sm-and-down" width="100%" :src="essential13[0]" alt="" />
                                <img class="hidden-md-and-up" width="100%" :src="essential13[1]" alt="" />
                              </div>
                            </el-collapse-item>
                            <el-collapse-item>
                              <div slot="title" class="item-txt">
                                <img src="../../assets/images/D/04.png" alt class="enen" />
                                <img src="../../assets/images/D/garden.png" alt class="item-i" />
                                <span class="item-txt-t">疑问解答</span>
                                <span class="item-txt-m">Question Answer</span>
                              </div>
                              <div class="tem-img">
                                <img class="hidden-sm-and-down" width="100%" :src="essential14[0]" alt="" />
                                <img class="hidden-md-and-up" width="100%" :src="essential14[1]" alt="" />
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                        </el-tab-pane>
                        <el-tab-pane label="" name="second">
                          <div class="item-header" v-html="essential2.ONE"></div>
                          <el-collapse accordion>
                            <el-collapse-item>
                              <div slot="title" class="item-txt">
                                <img src="../../assets/images/D/01.png" alt class="enen" />
                                <img src="../../assets/images/D/copy.png" alt class="item-i" />
                                <span class="item-txt-t">著作权</span>
                                <span class="item-txt-m">Copyright</span>
                              </div>
                              <div class="tem-img">
                                <img class="hidden-sm-and-down" width="100%" :src="essential21[0]" alt="" />
                                <img class="hidden-md-and-up" width="100%" :src="essential21[1]" alt="" />
                              </div>
                            </el-collapse-item>
                            <el-collapse-item>
                              <div slot="title" class="item-txt">
                                <img src="../../assets/images/D/02.png" alt class="enen" />
                                <img src="../../assets/images/D/trademark.png" alt class="item-i" />
                                <span class="item-txt-t">商标权</span>
                                <span class="item-txt-m">Trademark right</span>
                              </div>
                              <div class="tem-img">
                                <img class="hidden-sm-and-down" width="100%" :src="essential22[0]" alt="" />
                                <img class="hidden-md-and-up" width="100%" :src="essential22[1]" alt="" />
                              </div>
                            </el-collapse-item>
                            <el-collapse-item>
                              <div slot="title" class="item-txt">
                                <img src="../../assets/images/D/03.png" alt class="enen" />
                                <img src="../../assets/images/D/patent.png" alt class="item-i" />
                                <span class="item-txt-t">专利权</span>
                                <span class="item-txt-m">Patent right</span>
                              </div>
                              <div class="tem-img">
                                <img class="hidden-sm-and-down" width="100%" :src="essential23[0]" alt="" />
                                <img class="hidden-md-and-up" width="100%" :src="essential23[1]" alt="" />
                              </div>
                            </el-collapse-item>
                          </el-collapse>
                        </el-tab-pane>
                      </el-tabs>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane class="cyyy" label="税务、法务须知" name="3">
                  <div class="nav-title">
                    <img class="hidden-sm-and-down" width="60%" src="../../assets/images/D/TL.png" alt="" />
                    <img class="hidden-md-and-up" width="55%" src="../../assets/images/D/TL-m.png" alt="" />
                  </div>
                  <el-row type="flex" justify="center">
                    <el-col :sm="24" :md="20" :lg="20">
                      <el-collapse class="mian-left-l">
                        <div class="title-box">
                          <div>
                            <div class="text">主管单位：</div>
                            <div class="text">国家税务总局深圳市税务局</div>
                          </div>
                        </div>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/01.png" alt class="enen" />
                            <img src="../../assets/images/D/taxes.png" alt class="item-i" />
                            <span class="item-txt-t">常见的税种及税率</span>
                            <span class="item-txt-m">Taxes and tax rates</span>
                          </div>
                          <div class="tab" v-html="taxLaw.ONE"></div>
                        </el-collapse-item>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/02.png" alt class="enen" />
                            <img src="../../assets/images/D/concr.png" alt class="item-i" />
                            <span class="item-txt-t">税收知识</span>
                            <span class="item-txt-m">Tax knowledge</span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="taxLaw2[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="taxLaw2[1]" alt="" />
                          </div>
                        </el-collapse-item>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/03.png" alt class="enen" />
                            <img src="../../assets/images/D/legal.png" alt class="item-i" />
                            <span class="item-txt-t">法务须知</span>
                            <span class="item-txt-m">Legal Notice</span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="taxLaw3[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="taxLaw3[1]" alt="" />
                          </div>
                        </el-collapse-item>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/04.png" alt class="enen" />
                            <img src="../../assets/images/D/suggest.png" alt class="item-i" />
                            <span class="item-txt-t">财务、法务相关建议</span>
                            <span class="item-txt-m">Financial and legal suggestions</span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="taxLaw4[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="taxLaw4[1]" alt="" />
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane class="cyyy" label="签证选择与移民" name="4">
                  <div class="nav-title">
                    <img class="hidden-sm-and-down" width="100%" src="../../assets/images/D/VISA.png" alt="" />
                    <img class="hidden-md-and-up" width="80%" src="../../assets/images/D/VISA-m.png" alt="" />
                  </div>
                  <el-row type="flex" justify="center">
                    <el-col :sm="24" :md="20" :lg="20">
                      <el-collapse class="mian-left-l">
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/01.png" alt class="enen" />
                            <img src="../../assets/images/D/visa-icon.png" alt class="item-i" />
                            <span class="item-txt-t">签证种类的选择</span>
                            <span class="item-txt-m">Choice of Visa Types</span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="visa1[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="visa1[1]" alt="" />
                          </div>
                        </el-collapse-item>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/02.png" alt class="enen" />
                            <img src="../../assets/images/D/id-card.png" alt class="item-i" />
                            <span class="item-txt-t">首次办理外国人永久居留身份证</span>
                            <span class="item-txt-m" style="top: 80px;">
                              <p>Processing Foreigner's Permanent Residence</p>
                              <p>Identity Card for the First Time</p>
                            </span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="visa2[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="visa2[1]" alt="" />
                          </div>
                        </el-collapse-item>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/03.png" alt class="enen" />
                            <img src="../../assets/images/D/policy.png" alt="" class="item-i" />
                            <span class="item-txt-t">政策扶持</span>
                            <span class="item-txt-m">Policy support</span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="visa3[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="visa3[1]" alt="" />
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </el-col>
                  </el-row>
                </el-tab-pane>
                <el-tab-pane class="cyyy" label="公司设立指引" name="5">
                  <div class="nav-title">
                    <img class="hidden-sm-and-down" width="100%" src="../../assets/images/D/SET.png" alt="" />
                    <img class="hidden-md-and-up" width="50%" src="../../assets/images/D/SET-m.png" alt="" />
                  </div>
                  <el-row type="flex" justify="center">
                    <el-col :sm="24" :md="20" :lg="20">
                      <el-collapse class="mian-left-l">
                        <div class="title-box">
                          <div>
                            <div class="text">公司设立至可以运营，需要经过工商登记（申请公司营业执照）、</div>
                            <div class="text">刻制印章、企业银行开户等环节。</div>
                          </div>
                        </div>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/01.png" alt class="enen" />
                            <img src="../../assets/images/D/pencil.png" alt class="item-i" />
                            <span class="item-txt-t">工商登记（申请公司营业执照）</span>
                            <span class="item-txt-m">Business registrations</span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="setting1[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="setting1[1]" alt="" />
                          </div>
                        </el-collapse-item>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/02.png" alt class="enen" />
                            <img src="../../assets/images/D/seal.png" alt class="item-i" />
                            <span class="item-txt-t">刻制印章</span>
                            <span class="item-txt-m">Chapter moment</span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="setting2[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="setting2[1]" alt="" />
                          </div>
                        </el-collapse-item>
                        <el-collapse-item>
                          <div slot="title" class="item-txt">
                            <img src="../../assets/images/D/03.png" alt class="enen" />
                            <img src="../../assets/images/D/wallet.png" alt="" class="item-i" />
                            <span class="item-txt-t">公司银行账户开设</span>
                            <span class="item-txt-m">Company bank account opening</span>
                          </div>
                          <div class="tem-img">
                            <img class="hidden-sm-and-down" width="100%" :src="setting3[0]" alt="" />
                            <img class="hidden-md-and-up" width="100%" :src="setting3[1]" alt="" />
                          </div>
                        </el-collapse-item>
                      </el-collapse>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
              <div class="downn"><i class="el-icon-caret-bottom"></i></div>
            </div>
            <gotop></gotop>
          </el-col>
        </el-row>
      </div>
    </el-main>
    <el-footer>
      <vfooter class="hidden-sm-and-down"></vfooter>
      <ivfooter class="hidden-md-and-up"></ivfooter>
    </el-footer>
  </el-container>
</template>

<script>
import { szLifed1, szLifed11, szLifed21, szLifed22, szLifed3, szLifed4, szLifed5 } from '../../api'
import Gotop from '../../components/gotop'
export default {
  data () {
    return {
      activeName: 'first',
      tabPosition: 'right',
      acName: '1',
      btnFlag: false,
      subShow: false,
      subsidies: {},
      subsidies1: {},
      essential: {},
      essential12: {},
      essential13: {},
      essential14: {},
      essential2: {},
      essential21: {},
      essential22: {},
      essential23: {},
      taxLaw: {},
      taxLaw2: {},
      taxLaw3: {},
      taxLaw4: {},
      visa1: {},
      visa2: {},
      visa3: {},
      setting1: {},
      setting2: {},
      setting3: {},
      navTitle: [
        {
          txt: '个人政策'
        },
        {
          txt: '企业政策'
        }
      ],
      menuShow: false
    }
  },
  mounted () {
    window.addEventListener('scroll', this.scrollToTop)
    szLifed1().then(res => {
      this.subsidies = res.data[0]
      // console.log(res.data)
    })
    szLifed11().then(res => {
      this.subsidies1 = res.data[0].CONTENT
      this.subsidies1 = this.cutSrc(this.subsidies1)
    })
    szLifed21().then(res => {
      this.essential = res.data[0]
      this.essential12 = this.cutSrc(res.data[0].TWO)
      this.essential13 = this.cutSrc(res.data[0].THREE)
      this.essential14 = this.cutSrc(res.data[0].FOUR)
    })
    szLifed22().then(res => {
      this.essential2 = res.data[0]
      this.essential21 = this.cutSrc(res.data[0].TWO)
      this.essential22 = this.cutSrc(res.data[0].THREE)
      this.essential23 = this.cutSrc(res.data[0].FOUR)
    })
    szLifed3().then(res => {
      this.taxLaw = res.data[0]
      this.taxLaw2 = this.cutSrc(res.data[0].TWO)
      this.taxLaw3 = this.cutSrc(res.data[0].THREE)
      this.taxLaw4 = this.cutSrc(res.data[0].FOUR)
    })
    szLifed4().then(res => {
      this.visa1 = this.cutSrc(res.data[0].ONE)
      this.visa2 = this.cutSrc(res.data[0].TWO)
      this.visa3 = this.cutSrc(res.data[0].THREE)
      // console.log(this.visa)
    })
    szLifed5().then(res => {
      this.setting1 = this.cutSrc(res.data[0].ONE)
      this.setting2 = this.cutSrc(res.data[0].TWO)
      this.setting3 = this.cutSrc(res.data[0].THREE)
      // console.log(this.setting)
    })
    this.$nextTick(() => {
      $('#pane-1 #tab-first').append(
        `
			<p class="tit">个人政策</p>
			<p class="tit-name">Subsidy policies for individuals</p>
			`
      )
      $('#pane-1 #tab-second').append(
        `
			<p class="tit">企业政策</p>
			<p class="tit-name">Policies for enterprises</p>
			`
      )
      $('#pane-2 #tab-first').append(
        `
			<p class="tit">公司性质选择</p>
			<p class="tit-name">Choosing the right company type</p>
			`
      )
      $('#pane-2 #tab-second').append(
        `
			<p class="tit">知识产权</p>
			<p class="tit-name">Intellectual property</p>
			`
      )
    })
  },
  destroyed () {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  components: {
    Gotop
  },
  methods: {
    cutSrc (obj) {
      var a = obj.split('</p>')
      // eslint-disable-next-line no-array-constructor
      var b = new Array()
      for (var i = 0; i < a.length; i++) {
        if (a[i].indexOf('src') !== -1) {
          b.push(a[i].match(/src="(\S*)"/)[1])
        }
      }
      return b
    },
    menuOpen () {
      this.menuShow = !this.menuShow
    },
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    subSelect (e) {
      if (e === 0) {
        this.activeName = 'first'
      } else if (e === 1) {
        this.activeName = 'second'
      }
    },
    handleOpen (e) {
      // console.log(e)
    },
    handleClose (key, keyPath) {
      // console.log(key, keyPath)
    },
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop () {
      let that = this
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5)
        document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
        if (that.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },
    mainSelect (e) {
      console.log(e)
      this.acName = e
      this.menuShow = false
      this.backTop()
      if (e == 1) {
        this.navTitle = [
          {
            txt: '个人政策'
          },
          {
            txt: '企业政策'
          }
        ]
      } else if (e == 2) {
        this.navTitle = [
          {
            txt: '公司性质选择'
          },
          {
            txt: '知识产权'
          }
        ]
      }
      // console.log(document.getElementsByClassName('el-menu--inline'))
      // document.getElementsByClassName('el-menu--inline')[0].setAttribute('style', 'display:none')
    },
    getElementTopLeft (obj) {
      var top = 0
      var left = 0
      while (obj) {
        top += obj.offsetTop
        left += obj.offsetLeft
        obj = obj.offsetParent
      }
      return {
        top: top,
        left: left
      }
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop () {
      let that = this
      let num = 1
      if (this.acName <= 2) {
        num = this.acName
      } else {
        num = 3
      }
      let menuObj = document.getElementsByClassName('el-tabs__header')[num]
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      that.scrollTop = scrollTop
      if (that.scrollTop > 100) {
        that.btnFlag = true
      } else {
        that.btnFlag = false
      }
      if (num <= 2) {
        if (num === 1) {
          // eslint-disable-next-line standard/object-curly-even-spacing
          this.navTitle = []
          this.navTitle = this.navTitle.concat(
            {
              txt: '公司性质'
            },
            {
              txt: '知识产权'
            }
          )
        }
        if (this.getElementTopLeft(menuObj).top + menuObj.clientHeight > window.pageYOffset && window.pageYOffset + window.innerHeight > this.getElementTopLeft(menuObj).top) {
          this.subShow = false
          // console.log(num)
        } else {
          this.subShow = true
        }
      } else {
        this.subShow = false
      }
    }
  }
}
</script>

<style>
.el-collapse-item__content img {
  width: 100%;
}

.tem-img {
  padding: 0.7rem 0.4rem 0.2rem 0.4rem;
}

.nav-title {
  width: 80%;
  position: relative;
  text-align: left;
  margin-bottom: 0.8rem;
  /* margin-left: .58rem; */
}

.el-main {
  margin-top: 0;
  overflow: initial;
}

.mida {
  position: relative;
}

.mida .ec-top-foot {
  position: absolute;
  top: -1.23rem;
  left: 7%;
  background: rgba(0, 182, 205, 1);
  min-width: 6.5rem;
  height: 0.78rem;
  align-items: center;
}

.mida .ec-top-foot .el-breadcrumb {
  line-height: 0.78rem;
  padding-left: 10px;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__inner a {
  color: #fff;
  font-weight: 400;
}

.el-breadcrumb__item .el-breadcrumb__separator {
  color: #fff;
}

.sin {
  position: fixed;
  right: 1rem;
  top: 50%;
  width: 5px;
}

.sin a {
  display: inline-block;
  width: 3px;
  height: 60px;
  background: #d8d8d8;
}

.sin a:hover {
  width: 5px;
  background: #b1b0b0;
}

.el-popover {
  padding: 0;
}

.el-popover .el-popover__title {
  height: 20px;
  font-size: 0.3rem;
  text-align: center;
  align-items: center;
  line-height: 34px;
  color: #6a6969;
}

.nav-title-t {
  position: absolute;
  left: 82px;
  bottom: 16px;
  font-size: 26px;
  color: rgba(70, 70, 70, 1);
}

.mii .title-box {
  background: #f8f8f8;
  padding: 40px 0;
}

.mii .title-box .text {
  font-size: 0.3rem;
  font-weight: normal;
  color: #0fb7d1;
  text-align: left;
  padding: 0 100px;
}

.mii .title-box .text:nth-child(1) {
  margin-bottom: 5px;
}

.enkt img {
  position: absolute;
  top: 0;
  left: -30px;
  width: 890px;
  height: 100%;
  margin: 0;
}

.enkt .enkt-t {
  position: absolute;
  left: 53px;
  bottom: 22px;
  font-size: 24px;
  font-weight: 500;
  color: #464646;
}

.mian-right {
  position: relative;
  margin: auto;
  margin-top: 30px;
  padding-bottom: 2rem;
}

.mian-right h2 {
  position: absolute;
  right: 0;
  top: 0;
  padding-bottom: 30px;
}

.mian-right .nav {
  position: absolute;
  right: 58px;
  top: 50px;
}

.mian-right .nav div:nth-child(1) {
  font-size: 0.5rem;
  color: #0fb7d1;
  text-align: left;
  font-weight: bold;
  line-height: 40px;
}

.mian-right .nav div:nth-child(2) {
  font-size: 0.5rem;
  color: #464646;
  text-align: left;
  line-height: 25px;
}

.enen {
  position: absolute;
  top: 9px;
  left: 6px;
  height: 100px;
}

.item-txt-t {
  position: absolute;
  left: 103px;
  top: 45px;
  font-size: 0.3rem;
  font-weight: 400;
  color: #6a6969;
}

.item-txt-m {
  position: absolute;
  left: 103px;
  top: 64px;
  font-size: 0.1rem;
  color: #6a6969;
}

.item-txt-m p {
  line-height: 13px;
  text-align: left;
  font-size: 0.1rem;
  line-height: 0.22rem;
}

.item-i {
  position: absolute;
  left: 105px;
  top: 22px;
  height: 30px;
}

.item-txt-a {
  position: relative;
  height: 0.9rem;
  background: #f8f8f8;
  margin: 15px 0rem 0px 0.4rem;
}

.item-txt-b {
  float: left;
  height: 0.9rem;
  width: 0.9rem;
  line-height: 0.9rem;
  background: #16b9d2;
  color: #fff;
  font-size: 0.4rem;
}

.item-txt-c {
  height: 0.9rem;
  text-align: left;
  line-height: 0.9rem;
  padding-left: 1.2rem;
  font-size: 0.3rem;
}

.item-txt-d {
  margin: 0.14rem 0.4rem 0 0.4rem;
  text-align: left;
  padding-left: 1.2rem;
  font-size: 0.3rem;
}

.item-txt-box {
  position: relative;
  margin: 0.2rem 0.4rem 0 0.4rem;
}

.item-txt-question {
  height: 0.9rem;
  width: 0.9rem;
  line-height: 0.9rem;
  background: #aad044;
  color: #fff;
  float: left;
  font-size: 0.4rem;
}

.top-img {
  position: relative;
}

.top-img-top {
  position: absolute;
  top: 45%;
  left: 5%;
  color: #ffffff;
  text-align: left;
}

.top-img-top p {
  font-size: 0.6rem;
  font-weight: 600;
}

.top-img-top span {
  font-size: 0.45rem;
  font-weight: 300;
}

.top-img .top-img-top:after {
  content: '';
  position: absolute;
  left: 0;
  top: -16px;
  height: 1px;
  width: 40%;
  background: #fff;
}

.item-txt-answer {
  font-size: 0.27rem;
  padding-left: 1.2rem;
  padding-top: 0.1rem;
  line-height: 0.6rem;
  color: #6a6969;
  text-align: left;
}

/*.item-header{*/
/*  padding-top: 10px;*/
/*  width: 800px;*/
/*}*/
/*.item-header .item-header-s span{*/
/*  display: inline-block;*/
/*  width: 250px;*/
/*  background: #f8f8f8;*/
/*  padding: 10px 0;*/
/*  text-align: center;*/
/*  color: #b1b0b0;*/
/*}*/
/*.item-header .item-header-s span:nth-child(2){*/
/*  margin: 0 25px;*/
/*}*/
/*.item-header .item-header-text{*/
/*  padding: 10px  23px 0 23px;*/
/*  text-align: left;*/
/*}*/
/*.item-header .item-header-text p*/
/*{*/
/*  text-indent:2em;*/
/*  color: #b1b0b0;*/
/*  padding-bottom: 10px;*/
/*  margin-bottom: 0;*/
/*}*/
/*.copyright-info{*/
/*  margin: 30px 0;*/
/*}*/
/*.copyright-info .copyright-info-t{*/
/*  display: inline-block;*/
/*  margin-top: 25px;*/
/*  width: 550px;*/
/*  color: #6a6969;*/
/*}*/
/*.copyright-info .copyright-info-t span{*/
/*  display: inline-block;*/
/*  width: 100%;*/
/*  text-align: left;*/
/*}*/
/*.copyright-info .copyright-info-t p{*/
/*  padding-top: 17px;*/
/*  text-align: left;*/
/*}*/
/*.copyinfo-info-code{*/
/*  float: right;*/
/*  margin-right: 75px;*/
/*}*/
/*.copyinfo-info-code p{*/
/*  margin: 0 auto;*/
/*  padding: 0;*/
/*}*/
/*.copy-title{*/
/*  color: #0fb7d1;*/
/*  font-weight: normal;*/
/*  text-align: left;*/
/*}*/
/*.copy-introduce p{*/
/*  height: 500px;*/
/*}*/
/*.copy-introduce .flow-img{*/
/*  margin: 50px 0;*/
/*}*/
/*.copy-introduce .copy-statute-link img{*/
/*  padding: 0 10px;*/
/*}*/
.item-header .item-header-s .span {
  display: inline-block;
  width: 100%;
  background: #f8f8f8;
  padding: 10px 0;
  text-align: center;
  color: #b1b0b0;
}

.item-header .item-header-s span:nth-child(2) {
  margin: 0 25px;
}

.item-header .item-header-text {
  padding: 20px 15px 0 15px;
  text-align: left;
  font-size: 0.27rem;
  line-height: 24px;
}

.item-header .item-header-text p {
  text-indent: 2em;
  color: #b1b0b0;
  padding-bottom: 10px;
}

.copyright-info {
  margin: 30px 0;
}

.copyright-info .copyright-info-t {
  display: inline-block;
  float: left;
  margin-top: 25px;
  color: #6a6969;
}

.copyright-info .copyright-info-t span {
  display: inline-block;
  width: 100%;
  text-align: left;
}

.copyright-info .copyright-info-t p {
  padding-top: 17px;
  text-align: left;
}

.copyinfo-info-code {
  float: right;
  margin-right: 0.5rem;
}

.copyinfo-info-code p {
  margin: 0 auto;
  padding: 0;
}

.copy-title {
  color: #0fb7d1;
  font-weight: normal;
  text-align: left;
  font-size: 0.4rem;
  margin: 10px 0;
  padding-left: 0.4rem;
}

.copy-title:not(:first-child) {
  margin-top: 1.2rem;
}

.copy-introduce p {
  height: 500px;
}

.copy-introduce .flow-img {
  margin: 50px 0;
}

.copy-introduce .copy-statute-link {
  margin: 0.5rem 0;
  display: inline-block;
}

.go-top {
  position: fixed;
  bottom: 20px;
  right: 50px;
  vertical-align: middle;
}

.downn {
  position: absolute;
  right: 130px;
  top: 332px;
  color: #0fb7d1;
}

.el-menu-vers {
  width: 10px;
  min-height: 400px;
}

.el-tabs__nav-wrap .el-tabs__nav {
  width: 100%;
  padding-bottom: 0.4rem;
}

.el-tabs__item {
  color: #464646;
  padding: 0;
}

.mian-left-l .el-tabs__header {
  height: 1.6rem;
}

.mian-left-l .el-tabs__nav-wrap {
  background: #f8f8f8;
}

.mian-left-l .el-tabs__item {
  height: 85px;
  width: 50%;
  line-height: 85px;
  font-size: 0.5rem;
  color: #b1b0b0;
}

.mian-left-l .el-tabs__active-bar {
  position: absolute;
  top: 0;
  left: 0;
  width: 50% !important;
  background: #0fb7d1;
}

.mian-left-l .el-tabs__item:hover {
  color: #6a6969;
}

.is-right > .el-tabs__item:hover {
  color: #0fb7d1;
}

.mian-left-l .el-tabs__item .is-active {
  background: #0fb7d1;
}

.mian-left-l .el-tabs__nav-wrap::after {
  display: none;
}

.el-collapse-item__header {
  position: relative;
  border: none;
  height: 110px;
  margin-top: 27px;
  background: #f8f8f8;
  padding: 10px;
}

.el-collapse-item__header:hover .item-txt-t,
.el-collapse-item__header:hover .item-txt-m {
  color: #000;
}

.el-collapse {
  border: none;
}

.el-collapse-item__arrow {
  font-size: 0.6rem;
  color: #6e6d6d;
  position: absolute;
  top: 55%;
  right: 10%;
}

.is-right > .el-tabs__item {
  margin-left: 10px;
  border-bottom: 1px solid #87dbe8;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
}

.is-right > .is-active {
  background: #0fb7d1;
  color: #fff;
}

.is-right > .is-active:hover {
  color: #fff;
}

.is-right > .is-active:after {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 5px 8.7px 5px 0;
  border-color: transparent #0fb7d1 transparent transparent;
  content: '';
  position: absolute;
  z-index: 50;
  top: 43%;
  left: -5px;
}

.is-right > .el-tabs__nav-wrap {
  margin-top: 40px;
}

.is-right > .el-tabs__active-bar {
  border: none;
  background: transparent;
}

.is-right > .el-tabs__nav-wrap::after {
  height: 0;
  background: transparent;
}

.is-right > .el-tabs__content {
  position: relative;
}

/*税务*/
.tab {
  margin-top: 20px;
}

.tab .el-row {
  margin-bottom: 10px;
}

.tab .tab-header-td {
  position: relative;
  font-size: 0.3rem;
  height: 1.1rem;
  line-height: 1.1rem;
  color: #fff;
  background: #0fb7d1;
}

.tab .el-row .el-col:not(:last-child) .tab-header-td:after {
  content: '';
  position: absolute;
  top: 15%;
  right: 0;
  height: 70%;
  border-right: 1px solid #f8f8f8;
}

.tab .tab-content-tr {
  display: flex;
  background: #cdf2f8;
}

.tab .tab-content-td {
  position: relative;
  height: 100%;
  color: #6a6969;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.8rem 0.5rem;
}

.tab .el-row .el-col:last-child .tab-content-td {
  text-align: left;
}

.tab .el-row .el-col:not(:last-child) .tab-content-td:after {
  content: '';
  position: absolute;
  top: 8%;
  right: 0;
  height: 85%;
  border-right: 1px solid #b4d0d4;
}

.el-tabs--right .el-tabs__header.is-right {
  margin-top: 90px !important;
  position: relative;
  right: 62px;
}

/*补贴政策*/
.policy-centent-box {
  position: relative;
  display: flex;
  padding: 20px 0;
  margin: 0.5rem 0;
  z-index: -2;
}

.policy-centent-box:nth-child(2n + 1) {
  background: #f8f8f8;
}

.policy-centent-box .bg-number {
  position: absolute;
  top: 0;
  left: 5%;
  font-size: 2rem;
  color: rgba(241, 241, 241, 1);
  z-index: -1;
}

.policy-centent-box .policy-centent .main-title {
  font-size: 0.4rem;
  text-align: left;
  color: rgb(106, 105, 105);
  margin-top: 1.3rem;
  margin-left: 6%;
}

.policy-centent-box .policy-centent .sub-title {
  text-align: left;
  color: #0fb7d1;
  font-size: 0.4rem;
  margin-left: 6%;
  margin-top: 0.5rem;
}

.policy-centent-box .policy-centent .content-txt p {
  text-align: left;
  color: #464646;
  font-size: 0.3rem;
  margin: 0 6%;
  line-height: 0.6rem;
}

.policy-centent-box .policy-centent .content-txt p:first-child {
  margin-top: 0.1rem;
}

.policy-centent-box .code-box {
  position: relative;
  height: 100%;
}

.policy-centent-box .code-box .code {
  position: absolute;
  bottom: 52px;
  left: -26px;
}

.policy-centent-box .code-box .code-txt {
  position: absolute;
  bottom: 19px;
  left: 15px;
  font-size: 0.25rem;
  color: rgb(70, 70, 70);
}

/*设立指引*/
.set-guid {
  padding-top: 1rem;
}

.circuit-content {
  width: 70%;
  margin: 0.5rem auto;
}

.set-guid .copy-title span {
  color: #6a6969;
  font-size: 0.25rem;
}

.circuit-content p {
  text-align: left;
  color: #6a6969;
  font-size: 0.3rem;
  margin-top: 5px;
}

.materialList-box {
  background: #f8f8f8;
  padding: 0.4rem;
}

.set-guid .list-content {
  padding: 0 0.4rem;
}

.set-guid .list-content p {
  text-align: left;
}

.loginHall-box {
  padding: 0.4rem;
  margin-top: 0.7rem;
  background: #f8f8f8;
}

.loginHall-box .tab .el-row:nth-child(2n + 1) .tab-content-tr {
  background: #eef8cf;
}

.loginHall-box .title-note {
  text-align: left;
  color: #6a6969;
}

.loginHall-box .tab {
  margin: 0;
}

.loginHall-box .copy-title,
.materialList-box .copy-title {
  padding-left: 0;
}

/*签证*/
.materialList-box .subTitle,
.materialList-box .content-box p {
  text-align: left;
  font-size: 0.25rem;
  color: #696969;
  line-height: 0.5rem;
}

.set-guid .code-box {
  width: 33.3%;
  margin: 1rem auto 0 auto;
}

.set-guid .code-box .code-txt p {
  text-align: center;
  color: #0fb7d1;
}

/*手机端头部导航*/

.header-nav .main-h-nav {
  width: 33.333%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;
}

.header-nav {
  position: fixed;
  top: 1.1rem;
  width: 100%;
  z-index: 999;
  border-top: 1px solid #10b7d1;
  border-bottom: 1px solid #10b7d1;
  background: #222728f5;
  padding: 0 20px;
  font-size: 0.35rem;
}

.header-nav .sub-h-nav {
  height: 1rem;
}

.header-nav .sub-h-nav div {
  height: 100%;
  line-height: 1rem;
  color: #c8c8c8;
}

.header-nav .sub-h-nav div:active {
  color: #10b7d1;
}

.header-nav .sub-h-nav div:hover {
  color: #10b7d1;
}

.main-h-nav .el-submenu__title {
  height: 1rem;
  background: none !important;
}

.main-h-nav .el-submenu__title span {
  line-height: 1rem;
  display: inherit;
}

.el-submenu__title:focus,
.el-submenu__title:hover {
  background: rgba(0, 0, 0, 0.7);
}

.el-menu-item-group__title {
  display: none;
}

.el-menu-item-group ul {
  background: rgba(0, 0, 0, 0.7);
}

.el-menu-item:focus,
.el-menu-item {
  background: none !important;
}

.el-menu-item:focus,
.el-menu-item:hover {
  color: #10b7d1 !important;
}

/*修改版*/
.main-h-nav1 .menu {
  height: 1rem;
  line-height: 1rem;
  color: #c8c8c8;
  text-align: right;
}

.main-h-nav1 .menu span {
  padding-left: 0.3rem;
}

.main-h-nav1 .menu i {
  transition: transform 0.3s;
}

.main-h-nav1 .menu .is-open {
  transform: rotate(90deg);
}

.main-h-nav1 .menu:hover {
  color: #10b7d1;
}

.main-h-nav1 .menu-list {
  position: absolute;
  right: -20px;
  width: 56%;
  height: 50rem;
  background: #222728f5;
  color: #c8c8c8;
  text-align: right;
  border-top: 1px solid #10b7d1;
}

.main-h-nav1 .menu-list ul {
  margin-top: 0.8rem;
}

.main-h-nav1 .menu-list .menu-item {
  line-height: 1.5rem;
  text-align: right;
  padding-right: 20px;
}

.main-h-nav1 .menu-list .menu-item:hover {
  color: #10b7d1;
}

.main-h-nav1 .menu-list .back-btn {
  display: inline-block;
  margin-right: 20px;
  padding: 0.15rem 0.5rem;
  margin-top: 0.5rem;
  border: 1px solid #c8c8c8;
}

.main-h-nav1 .menu-list .back-btn span {
  padding-left: 5px;
}

.menu-fade-enter-active {
  animation: fadeInRightBig 0.5s;
}

.menu-fade-leave-active {
  animation: fadeInRightBig 0.5s reverse;
}

.el-tabs__content .el-tabs__nav-wrap .el-tabs__item.is-active {
  color: #0fb7d1;
}

.top-img .ec-top-foot {
  position: absolute;
  bottom: 5px;
  left: 16%;
  background: rgba(0, 182, 205, 1);
  min-width: 6.5rem;
  height: 0.78rem;
  align-items: center;
}

.top-img .ec-top-foot .el-breadcrumb {
  line-height: 0.78rem;
  padding-left: 10px;
}

@keyframes fadeInRightBig {
  from {
    opacity: 0;
    -webkit-transform: translate3d(2000px, 0, 0);
    transform: translate3d(2000px, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@media screen and (min-width: 990px) {
  .item-header-s .el-row {
    display: flex;
    justify-content: center;
  }

  .item-header-s .el-row .el-col:not(:first-child) {
    margin-left: 4.166667%;
  }

  .hidden-md-and-u {
    display: none;
  }
}

@media screen and (max-width: 990px) {
  .hidden-md-and-d {
    display: none;
  }

  .top-img .ec-top-foot {
    display: none;
  }

  .title-box {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .item-header .item-header-s .span {
    margin-bottom: 10px;
  }

  .item-header .item-header-text {
    padding: 20px 0 0 0 !important;
  }

  .tab {
    padding: 0;
  }

  .policy-centent-box {
    display: inline-block;
  }

  .policy-centent-box .code-box .code {
    position: static;
    width: 50%;
    margin: 20px auto 0 auto;
  }

  .policy-centent-box .code-box .code-txt {
    position: static;
  }

  .el-tabs--right .el-tabs__header.is-right,
  .downn,
  .nav {
    display: none;
  }

  .copyright-info .copyright-info-t {
    float: none;
  }

  .copyinfo-info-code {
    float: none;
    margin-top: 0.5rem;
  }

  .mii #tab-first:before,
  .mii #tab-second:before {
    /* width: .8518rem;
			height: .8518rem; */
    display: none !important;
  }

  .mii #tab-first .tit::before,
  .mii #tab-second .tit::before {
    /* display: ; */
  }

  .mii #tab-first,
  .mii #tab-second {
    text-align: left !important;
    text-indent: 0 !important;
    line-height: 2rem;
    padding-bottom: 38px !important;
  }

  .mii #pane-1 .tit-name,
  .mii #pane-2 .tit-name {
    font-size: 0.1rem;
    top: 0;
    left: 0;
    display: block;
    white-space: normal;
    word-break: break-word;
    line-height: initial;
    text-indent: 0;
    padding: 0px 0 0 1.58rem !important;
    margin: -40px 0 0 0 !important;
    text-align: left;
    /* display: none !important; */
  }

  .mii #pane-2 #tab-first .tit-name {
    padding: 0px 0 0 1.58rem !important;
  }

  .mii #tab-first .tit,
  .mii #tab-second .tit {
    display: inline-block !important;
    padding-bottom: 0 !important;
    margin: 0 0 0 0.5rem;
    font-size: 0.4rem !important;
  }

  .mii #pane-1 .tit::before,
  .mii #pane-2 .tit::before {
    display: inline-block !important;
  }

  .el-tabs__nav-wrap .el-tabs__nav {
    padding-bottom: 0 !important;
  }
  .mii .el-tabs__content #tab-first .tit::before,
  .mii .el-tabs__content #tab-second .tit::before {
    top: 0.33rem !important;
  }
}

@media screen and (max-width: 760px) {
  .el-collapse-item__arrow {
    right: 0;
  }

  .title-box .text {
    padding: 0 20px !important;
  }

  .el-submenu .el-menu {
    width: 200px;
    margin-left: -64px;
  }

  .mii #tab-first:before,
  .mii #tab-second:before {
    /* width: .5518rem !important;
			height: .5518rem !important;
			margin: -.3359rem 0 0 0 !important;
			left: .4rem !important; */
    display: none !important;
  }

  .mii #tab-first,
  .mii #tab-second {
    min-height: 2rem !important;
    /* 			text-indent: 1.3rem !important;*/
    text-align: center !important;
    font-size: 0.42rem;
    padding-bottom: 0 !important;
  }

  .mii #pane-1 .tit-name,
  .mii #pane-2 .tit-name {
    /* left: 0rem !important;
			width: 100% !important;
			word-break: break-word !important;
			white-space: normal !important;
			line-height: 1 !important;
			padding: 1.25rem .3rem 0 !important; */
    display: none !important;
  }

  .mii #tab-first .tit,
  .mii #tab-second .tit {
    padding-top: 0.2rem;
    display: inline-block !important;
    margin: 0;
  }

  .mii #pane-1 .tit::before,
  .mii #pane-2 .tit::before {
    display: inline-block !important;
  }

  .el-tabs__nav-wrap .el-tabs__nav {
    padding-bottom: 0 !important;
  }
  .mii .el-tabs__content #tab-first .tit::before,
  .mii .el-tabs__content #tab-second .tit::before {
    top: 0.2rem !important;
  }
}
.el-collapse-item__wrap {
  border-bottom-width: 0;
}

.mii #tab-first,
.mii #tab-second {
  font-size: 0.3rem;
  position: relative;
  /* min-height: 2rem; */
  text-align: left;
  text-indent: 1.2rem;
  height: 100%;
  padding-bottom: 12px;
}

.mii #pane-1 #tab-first:before {
  content: '';
  position: absolute;
  width: 35px;
  height: 35px;
  background: url(../../assets/images/D/tab-icon1.png) no-repeat center 0/100% 100%;
  transform: translate(0, -25%);
  top: 50%;
  left: 0.35rem;
}

.mii #pane-1 #tab-second:before {
  content: '';
  position: absolute;
  width: 35px;
  height: 35px;
  background: url(../../assets/images/D/tab-icon2.png) no-repeat center 0/100% 100%;
  transform: translate(0, -25%);
  top: 50%;
  left: 0.35rem;
}

.mii #pane-2 #tab-first:before {
  content: '';
  position: absolute;
  width: 35px;
  height: 35px;
  background: url(../../assets/images/D/tab-icon3.png) no-repeat center 0/100% 100%;
  transform: translate(0, -25%);
  top: 50%;
  left: 0.35rem;
}

.mii #pane-2 #tab-second:before {
  content: '';
  position: absolute;
  width: 35px;
  height: 35px;
  background: url(../../assets/images/D/tab-icon4.png) no-repeat center 0/100% 100%;
  transform: translate(0, -25%);
  top: 50%;
  left: 0.35rem;
}

.mii #pane-1 #tab-first.is-active:before,
.mii .el-tabs__content #pane-1 #tab-first.is-active .tit::before {
  background: url(../../assets/images/D/tab-icon1-act.png) no-repeat center 0/100% 100% !important;
}

.mii #pane-1 #tab-second.is-active:before,
.mii .el-tabs__content #pane-1 #tab-second.is-active .tit::before {
  background: url(../../assets/images/D/tab-icon2-act.png) no-repeat center 0/100% 100%;
}

.mii #pane-2 #tab-first.is-active:before,
.mii .el-tabs__content #pane-2 #tab-first.is-active .tit::before {
  background: url(../../assets/images/D/tab-icon3-act.png) no-repeat center 0/100% 100%;
}

.mii #pane-2 #tab-second.is-active:before,
.mii .el-tabs__content #pane-2 #tab-second.is-active .tit::before {
  background: url(../../assets/images/D/tab-icon4-act.png) no-repeat center 0/100% 100%;
}

.mii #pane-1 .mian-left-l #tab-first.el-tabs__item:hover::before,
.mii #pane-1 .mian-left-l #tab-first:hover .tit::before {
  background: url(../../assets/images/D/tab-icon1-hover.png) no-repeat center 0/100% 100%;
}

.mii #pane-1 .mian-left-l #tab-second.el-tabs__item:hover::before,
.mii #pane-1 .mian-left-l #tab-second:hover .tit::before {
  background: url(../../assets/images/D/tab-icon2-hover.png) no-repeat center 0/100% 100%;
}

.mii #pane-2 .mian-left-l #tab-first.el-tabs__item:hover::before,
.mii #pane-2 .mian-left-l #tab-first:hover .tit::before {
  background: url(../../assets/images/D/tab-icon3-hover.png) no-repeat center 0/100% 100%;
}

.mii #pane-2 .mian-left-l #tab-second.el-tabs__item:hover::before,
.mii #pane-2 .mian-left-l #tab-second:hover .tit::before {
  background: url(../../assets/images/D/tab-icon4-hover.png) no-repeat center 0/100% 100%;
}

.mii #pane-1 .mian-left-l #tab-first.el-tabs__item.is-active:hover::before,
.mii .el-tabs__content #pane-1 .mian-left-l #tab-first.is-active:hover .tit::before {
  background: url(../../assets/images/D/tab-icon1-act.png) no-repeat center 0/100% 100%;
}

.mii #pane-1 .mian-left-l #tab-second.el-tabs__item.is-active:hover::before,
.mii .el-tabs__content #pane-1 .mian-left-l #tab-second.is-active:hover .tit::before {
  background: url(../../assets/images/D/tab-icon2-act.png) no-repeat center 0/100% 100%;
}

.mii #pane-2 .mian-left-l #tab-first.el-tabs__item.is-active:hover::before,
.mii .el-tabs__content #pane-2 .mian-left-l #tab-first.is-active:hover .tit::before {
  background: url(../../assets/images/D/tab-icon3-act.png) no-repeat center 0/100% 100%;
}

.mii #pane-2 .mian-left-l #tab-second.el-tabs__item.is-active:hover::before,
.mii .el-tabs__content #pane-2 .mian-left-l #tab-second.is-active:hover .tit::before {
  background: url(../../assets/images/D/tab-icon4-act.png) no-repeat center 0/100% 100%;
}

.mii #pane-1 .tit-name,
.mii #pane-2 .tit-name {
  /* position: absolute; */
  font-size: 0.1rem;
  top: 0;
  left: 0;
  display: block;
  white-space: normal;
  word-break: break-word;
  line-height: initial;
  text-indent: 0;
  padding: 0px 0 0 65px;
  margin: -30px 0 0 0;
  /* max-height: 1rem; */
}

.mii #pane-2 #tab-first .tit-name {
  left: 0;
}

.mii .el-tabs__content #tab-first .tit,
.mii .el-tabs__content #tab-second .tit {
  display: block;
}

.mii .el-tabs__content #pane-1 #tab-first .tit::before {
  content: '';
  position: relative;
  display: inline-block;
  width: 35px;
  height: 35px;
  background: url(../../assets/images/D/tab-icon1.png) no-repeat center 0/100% 100%;
  margin: 0 0.4rem 0 0;
  top: 0.27rem;
  display: none;
}

.mii .el-tabs__content #pane-1 #tab-second .tit::before {
  content: '';
  position: relative;
  display: inline-block;
  width: 35px;
  height: 35px;
  background: url(../../assets/images/D/tab-icon2.png) no-repeat center 0/100% 100%;
  margin: 0 0.4rem 0 0;
  top: 0.27rem;
  display: none;
}

.mii .el-tabs__content #pane-2 #tab-first .tit::before {
  content: '';
  position: relative;
  display: inline-block;
  width: 35px;
  height: 35px;
  background: url(../../assets/images/D/tab-icon3.png) no-repeat center 0/100% 100%;
  margin: 0 0.4rem 0 0;
  top: 0.27rem;
  display: none;
}

.mii .el-tabs__content #pane-2 #tab-second .tit::before {
  content: '';
  position: relative;
  display: inline-block;
  width: 35px;
  height: 35px;
  background: url(../../assets/images/D/tab-icon4.png) no-repeat center 0/100% 100%;
  margin: 0 0.4rem 0 0;
  top: 0.27rem;
  display: none;
}

.mii .el-tabs__content .el-tabs__nav.is-top {
  display: flex;
}

.mii .item-header {
  margin-top: 27px;
}
</style>
<style lang="less">
  .cityD{
    .cnts-item{
      text-align: left;
      &.i-one{
        h1{
          color: #6a6969;
          font-size: 0.3rem;
        }
        i{
          color: #0fb7d1;
          font-size: .3rem;
          font-style: initial;
          display: block;
          position: relative;
          padding-left: .3rem;
        }
        >ul{
          >li{
            padding: 1.4888rem 0 0 .4rem;
            text-align: justify;
            line-height: 1.75;
            >div{
              i{
                color: #0fb7d1;
                font-size: .3rem;
                font-style: initial;
                display: block;
                position: relative;
                span{
                  position: absolute;
                  color: #f1f1f1;
                  font-size: 1.5518rem;
                  bottom: 0;
                  left: 0;
                  line-height: .9;
                  z-index: -1;
                }
              }
              p{
                color: #464646;
                display: block;
                font-size: 0.25rem;
              }
              >.one-left-row{
                margin-top: .4rem;
                >.el-col{
                  padding-right: 2%;
                  position: relative;
                  &:nth-child(2n){
                    >div{
                      background: #a5cd39;
                    }
                  }
                  >div{
                    position: relative;
                    background: #0fb7d1;
                    padding: .8rem .3rem .3rem;
                    line-height: initial;
                    height: 100%;
                    &::before{
                      content: '';
                      display: block;
                      position: absolute;
                      width: 0;
                      height: 0;
                      border-width: .3rem;
                      border-color: #fff transparent transparent transparent;
                      border-style: solid;
                      z-index: 1;
                      top: 0;
                      left: 50%;
                      transform: translateX(-50%);
                    }
                    img{
                      display: block;
                      margin: 0 auto .3rem;
                      width: 100%;
                    }
                    >h3{
                      color: #fff;
                      font-size: .3rem;
                      display: block;
                    }
                    >p{
                      color: #fff;
                      font-size: .25rem;
                    }
                  }
                }
              }
            }
          }
        }
        .one-left-row2{
          padding-left: .3rem;
          ul{
            font-size: .25rem;
            li{
              background: #cff1f6;
              padding: .1rem 0 .1rem .1rem;
              &:nth-child(2n){
                background: #f6f6f6;
              }
            }
          }
        }
      }
    }
  }
</style>
